import { createAction } from '@reduxjs/toolkit';

export const selectVoipSettings = createAction<string>('SELECT_VOIP_SETTINGS');
export const resetVoipUpdateStatus = createAction('RESET_VOIP_UPDATE_STATUS');
export const deleteVoipRule = createAction<string | undefined>('DELETE_VOIP_RULE');
